module.exports = __webpack_public_path__ + "media/images/logo-f9a9217c398787fe0ae303bf22b4b416.png";